import React from "react";

import {
  capitalizeString,
  formatCurrency,
  getPreviewImage,
} from "../../../../../utilities/helpers";

import Form from "react-bootstrap/Form";
import Stack from "react-bootstrap/Stack";
import Image from "react-bootstrap/Image";

import placeholder from "../../../../../assets/placeholder.png";

function getPriceRange(map) {
  const pricingLevels = map?.pricingLevels;
  if (!pricingLevels || typeof pricingLevels !== "object") return null;
  const prices = Object.values(pricingLevels)
    .map((pl) => {
      const val = pl?.price ?? pl?.cost;
      const num = typeof val === "number" ? val : parseFloat(val);
      return typeof num === "number" && !Number.isNaN(num) ? num : null;
    })
    .filter((p) => p != null);
  if (prices.length === 0) return null;
  return {
    low: Math.min(...prices),
    high: Math.max(...prices),
  };
}

export default function Item({
  venueSlug,
  map,
  isExisting,
  isTemplate,
  selectedTemplate,
  selected,
  setSelected,
}) {
  const { id, type } = map;

  // isTemplate
  // is on template screen select the selectedTemplate else don't select radio buttons on create new map screen
  // if not template
  // is on create new map screen select the selected else don't select radio buttons on template screen
  const getSelected = () => {
    if (isTemplate) {
      if (isExisting) {
        return selectedTemplate == id;
      } else return false;
    }
  };

  return (
    <li
      className={`map-item list-item list-item-lg list-item--hover-primary ${selected == id ? "selected" : ""} `}
    >
      <Form.Check
        type="radio"
        className="form-check-display m-0"
        id={`map-type-display-checkbox-${id}`}
      >
        <Form.Check.Input
          type="radio"
          name="map-type"
          value={id}
          checked={selected == id}
          onChange={(e) => setSelected(e.target.value)}
          className="flex-shrink-0"
        />
        <Stack
          direction="horizontal"
          gap={3}
          className="flex-grow-1 order-first"
        >
          <Form.Check.Label
            id={`map-type-display-checkbox-${id}`}
            className="m-0 d-flex gap-3 w-100 h-100 align-items-center"
          >
            <Image
              src={getPreviewImage(venueSlug) || placeholder}
              alt={`Picture of ${capitalizeString(map.name)} map`}
              width="87"
              height="44"
              className="py-2"
            />
            <Stack className="justify-content-center">
              <span className="text-upper">{map.name || type}</span>
              {isExisting && (
                <Stack gap={1} as="ul">
                  {map.configuration && (
                    <li>{capitalizeString(map.configuration)}</li>
                  )}
                  <li>
                    <span className="text-muted me-1">Base Price:</span>{" "}
                    <span className="fw-semi-bold">
                      {formatCurrency(
                        map?.price?.low ?? getPriceRange(map)?.low ?? 0,
                      )}
                      <span className="to">
                        {formatCurrency(
                          map?.price?.high ?? getPriceRange(map)?.high ?? 0,
                        )}
                      </span>
                    </span>
                  </li>
                </Stack>
              )}
            </Stack>
          </Form.Check.Label>
        </Stack>
      </Form.Check>
    </li>
  );
}
